import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 2.75c-3.988 0-7.25 3.311-7.25 7.432 0 .954.382 2.13 1.042 3.409.651 1.264 1.538 2.56 2.463 3.73a29.185 29.185 0 0 0 2.638 2.925c.383.366.71.646.956.83.058.043.108.079.151.107.043-.028.093-.064.15-.107.247-.184.574-.464.957-.83a29.186 29.186 0 0 0 2.638-2.926c.925-1.17 1.812-2.465 2.463-3.729.66-1.278 1.042-2.455 1.042-3.41 0-4.12-3.262-7.431-7.25-7.431Zm-.161 18.527.011-.005a.08.08 0 0 1-.011.005Zm.31-.005a.06.06 0 0 1 .012.005l-.011-.005ZM3.25 10.182C3.25 5.265 7.152 1.25 12 1.25s8.75 4.015 8.75 8.932c0 1.305-.506 2.735-1.208 4.096-.71 1.376-1.656 2.753-2.62 3.972-.965 1.221-1.96 2.301-2.78 3.082-.407.389-.782.714-1.095.947a3.84 3.84 0 0 1-.454.298 1.275 1.275 0 0 1-.593.173c-.257 0-.48-.112-.593-.173a3.84 3.84 0 0 1-.454-.298 12.48 12.48 0 0 1-1.096-.947 30.676 30.676 0 0 1-2.779-3.082c-.964-1.219-1.91-2.596-2.62-3.972-.701-1.36-1.208-2.79-1.208-4.096Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 7.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM8.25 10a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorMap;
